import { useApp } from '../common/AppProvider';
import './alert-popups.css';
import AlertPopup from './AlertPopup';

const AlertPopupList = () => {
    const { alerts } = useApp();

    return (
        <div className="alert-popup-container">
            {alerts.map((alert) => (
                <AlertPopup key={alert.id} alert={alert} />
            ))}
        </div>
    );
};

export default AlertPopupList;
